
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LoadingPage',
  setup() {
    return {}
  },
})
